module.exports = __webpack_public_path__ + "img/img_3_five_intelligence@3x.3b065660.png";